import { render, staticRenderFns } from "./AppCheckboxGroup.vue?vue&type=template&id=395333a4&scoped=true&"
import script from "./AppCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./AppCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./AppCheckboxGroup.vue?vue&type=style&index=0&id=395333a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395333a4",
  null
  
)

export default component.exports